import axios from '@axios'

const PREFIX = '/envio-automatico'

export default {
  getConfigs() {
    return axios.get(`${PREFIX}`)
  },

  salvarConfig(config) {
    return axios.post(`${PREFIX}`, config)
  },

  salvarEmpresas(tipoRotina, empresasIds) {
    return axios.put(`${PREFIX}/${tipoRotina}/empresas`, empresasIds)
  },

  getLogsPaged(tipoRotina, pagina, tamanhoPagina) {
    return axios.get(`${PREFIX}/log/${tipoRotina}`, { params: { pagina, tamanhoPagina } })
  },

  getHistoricoEnviosPaged(tipoRotina, pagina, tamanhoPagina) {
    return axios.get(`${PREFIX}/historico-envios/${tipoRotina}`, { params: { pagina, tamanhoPagina } })
  },

  getEmpresasParaVinculo(tipoRotina) {
    return axios.get('/usuarios/empresas', { params: { tipoRotina } })
  },
}
